import { atom } from "jotai";
import type { ReactNode } from "react";
import type { Edge, EdgeMode } from "react-native-safe-area-context/src/SafeArea.types";
import type { LiftColors } from "../theme";

export type ModalInstance = {
    id: string;
    visible: boolean;
    children: ReactNode;
    onClose?: () => void;
    hideContainerBackground?: boolean;
    hideCloseButton?: boolean;
    fitContent?: boolean;
    bgColorName?: keyof LiftColors;
    edges?: Partial<Record<Edge, EdgeMode>>;
};

export const modalStackAtom = atom<ModalInstance[]>([]);

let modalIdCounter = 0;

export const generateModalId = () => {
    modalIdCounter += 1;
    return `modal-${modalIdCounter}`;
};

// Ordered ids of currently-mounted navigation-modal wrappers (web), in mount == stack order. Unlike
// modalStackAtom (JS modals rendered by ModalPortal), navigation modals are react-navigation screens
// living in a different engine; this lets each one tell how many nav modals sit above it so it can
// recede/hide behind them (see hooks/use-modal-recede-style.ts). JS modals always render above all
// nav modals, so a nav modal's total depth is (nav modals above it) + (visible JS modals).
export const navModalStackAtom = atom<string[]>([]);

let navModalIdCounter = 0;

export const generateNavModalId = () => {
    navModalIdCounter += 1;
    return `nav-modal-${navModalIdCounter}`;
};
